import { CommonSchemaIds } from './common.const.js';
import { DomainSchemaIds, DomainTags } from "./domain.const.js";
export const DOMAIN_TLMD_SCHEMAS = {
    [DomainSchemaIds.DOMAIN]: {
        id: DomainSchemaIds.DOMAIN,
        schema: {
            unevaluatedProperties: false,
        },
        properties: {
            _id: {
                ref: CommonSchemaIds.UUID,
                required: true,
                usage: [DomainTags.AS_TEAM, DomainTags.AS_ACCOUNT],
            },
            name: {
                ref: CommonSchemaIds.NAME,
                required: true,
                usage: [
                    { tag: DomainTags.AS_TEAM },
                    { tag: DomainTags.AS_ACCOUNT },
                ],
            },
            title: {
                ref: CommonSchemaIds.TITLE,
                required: true,
                usage: [
                    { tag: DomainTags.AS_TEAM },
                    { tag: DomainTags.AS_ACCOUNT },
                ],
            },
            reseller: {
                ref: CommonSchemaIds.RESELLER,
                required: true,
                usage: [
                    { tag: DomainTags.AS_TEAM },
                    { tag: DomainTags.AS_ACCOUNT, input: { create: -1, read: -1, update: -1 } }
                ],
            },
            administrators: {
                ref: CommonSchemaIds.DOMAIN_ADMINISTRATORS,
                required: true,
                usage: [
                    { tag: DomainTags.AS_TEAM },
                    { tag: DomainTags.AS_ACCOUNT, input: { create: -1, read: 1, update: 1 } },
                ],
            },
            active: {
                ref: CommonSchemaIds.ACTIVE,
                required: true,
                usage: [
                    { tag: DomainTags.AS_TEAM, input: { create: -1, read: 1, update: 1 } },
                    { tag: DomainTags.AS_ACCOUNT, input: { create: -1, read: 1, update: 1 } },
                ],
            },
            deleted: {
                ref: CommonSchemaIds.DELETED,
                required: true,
                usage: [
                    { tag: DomainTags.AS_TEAM, input: { create: -1, read: 1, update: 1 } },
                    { tag: DomainTags.AS_ACCOUNT, input: { create: -1, read: 1, update: 1 } },
                ],
            },
        },
    }
};
